import React from 'react';

import createSvgIcon from '../../utilities/createSvgIcon';

export default createSvgIcon(
  <>
    <g fill="none" fillRule="evenodd">
      <path
        d="M120.105 0L163 65l-42.895 65h-77.21L0 65 42.895 0h77.21zm-5.382 10H48.276L11.981 65l36.296 55h66.445l36.296-55-36.295-55z"
        fill="#FFF"
        fillRule="nonzero"
      />
      <path
        fill="#00B1AA"
        fillRule="nonzero"
        d="M114.723 10H48.276L11.981 65l36.296 55h66.445l36.296-55z"
      />
      <g transform="translate(37 20)">
        <rect fill="#00416F" x="6" y="24.615" width="78" height="55.385" rx="27.692" />
        <path
          d="M59.419 36.923c8.601.01 15.571 6.892 15.581 15.385l-.004.313c-.178 8.348-7.082 15.062-15.577 15.071H52l-10 6.154v-6.154H30.581c-8.495-.01-15.399-6.723-15.577-15.07L15 52.307l.004-.314c.178-8.348 7.082-15.061 15.577-15.07z"
          fill="#FFF"
          fillRule="nonzero"
        />
        <path
          d="M57 30.77c0-6.77-1.781-12.308-12-12.308S33 24 33 30.769h24zM39 6.154C39 2.755 41.686 0 45 0s6 2.755 6 6.154-2.686 6.154-6 6.154-6-2.755-6-6.154z"
          fill="#00416F"
        />
        <path
          fill="#00416F"
          d="M42 9.231h6v12.308h-6zM11.522 40C4.86 40.793 0 43.695 0 52.374c0 8.214 4.416 11.269 10.605 12.24 1.124.174 1.964-24.74.917-24.614zM78.478 40C85.14 40.793 90 43.695 90 52.374c0 8.214-4.416 11.269-10.605 12.24-1.124.174-1.964-24.74-.917-24.614z"
        />
        <path
          d="M26.873 57.212L30 54.085l3.127 3.127a.983.983 0 001.39 0l.695-.695a.983.983 0 000-1.39L32.085 52l3.127-3.127a.983.983 0 000-1.39l-.695-.695a.983.983 0 00-1.39 0L30 49.915l-3.127-3.127a.983.983 0 00-1.39 0l-.695.695a.983.983 0 000 1.39L27.915 52l-3.127 3.127a.983.983 0 000 1.39l.695.695a.983.983 0 001.39 0zM56.873 57.212L60 54.085l3.127 3.127a.983.983 0 001.39 0l.695-.695a.983.983 0 000-1.39L62.085 52l3.127-3.127a.983.983 0 000-1.39l-.695-.695a.983.983 0 00-1.39 0L60 49.915l-3.127-3.127a.983.983 0 00-1.39 0l-.695.695a.983.983 0 000 1.39L57.915 52l-3.127 3.127a.983.983 0 000 1.39l.695.695a.983.983 0 001.39 0z"
          fill="#00416F"
          fillRule="nonzero"
        />
      </g>
    </g>
  </>,
  'ErrorScreen',
  { viewBox: '0 0 163 130' }
);
